import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.grey[50],
        minHeight: '100vh',
        minWidth: '95%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
            minWidth: '100%',
        },
    },
    paper: {
        padding: theme.spacing(3),
        borderRadius: 16,
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.08)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1.5),
            borderRadius: 8,
        },
    },
    header: {
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(1),
        },
    },
    // Header mobile : empilé verticalement
    headerMobile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    headerActions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            '& > *': {
                width: '100%',
            },
        },
    },
    title: {
        fontWeight: 700,
        color: theme.palette.text.primary,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem',
        },
    },
    rowContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        padding: '0 2px 6px 2px',
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.2s ease-in-out',
        '&:hover': { backgroundColor: theme.palette.action.hover },
        [theme.breakpoints.down('sm')]: {
            padding: '4px 2px 8px 2px',
            marginBottom: theme.spacing(0.5),
        },
    },
    inputSection: {
        flex: 1,
        marginRight: theme.spacing(0),
    },
    priceDisplay: {
        minWidth: 100,
        textAlign: 'right',
        color: theme.palette.primary.main,
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            minWidth: 70,
            fontSize: '1rem',
        },
    },
    totalRow: {
        fontSize: '1.75rem',
        marginTop: theme.spacing(0),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    totalText: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        },
    },
    totalPrice: {
        fontSize: '1.25rem',
        color: theme.palette.primary.dark,
        fontWeight: 700,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        },
    },
    stoneTable: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            '& .MuiTableCell-root': {
                padding: '4px 6px',
                fontSize: '0.75rem',
            },
        },
    },
    tableHeader: {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        fontSize: '0.8rem',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.7rem',
            padding: '4px 4px',
        },
    },
    tableCell: {
        fontSize: '0.8rem',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.7rem',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        },
    },
    // Description dans le tableau : tronquée sur mobile
    tableCellDesc: {
        fontSize: '0.8rem',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.7rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 120,
        },
    },
    deleteButton: { color: theme.palette.error.main },
    buttonContainer: { marginTop: theme.spacing(3), textAlign: 'center' },
    totalColumn: { display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' },
    verticalDivider: {
        backgroundColor: theme.palette.divider,
        width: 1,
        height: 'auto',
        margin: theme.spacing(0, 2),
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    // Divider horizontal visible uniquement sur mobile
    horizontalDividerMobile: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            margin: theme.spacing(1, 0),
        },
    },
    finalPrice: {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: theme.palette.primary.dark,
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem',
        },
    },
    selectableRow: { cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover } },
    // Stone form : empilé sur mobile
    stoneFormField: {
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(0.5),
        },
    },
    // Total blocks : grille responsive
    totalBlocksGrid: {
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap !important',
        },
    },
    totalBlockItem: {
        [theme.breakpoints.down('sm')]: {
            minWidth: '45%',
            flex: '1 1 45% !important',
            marginBottom: theme.spacing(1),
        },
    },

    printFlexRow: {
        '@media print': {
            display: 'flex !important',
            flexDirection: 'row !important',
            justifyContent: 'space-between !important',
            alignItems: 'flex-start !important',
            width: '100% !important',
            flexWrap: 'nowrap !important',
        },
    },
    printFlexItem: {
        '@media print': {
            flex: '1 1 33% !important',
            maxWidth: '33% !important',
            boxSizing: 'border-box',
        },
    },
    mainContent: {
        flex: 1,
        transition: 'margin-left 0.3s',
        '@media print': {
            marginLeft: '0 !important',
        },
    },
    // Panneau historique des devis
    historyPanel: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 400,
    },
    historyList: {
        flex: 1,
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 200px)',
    },
    historyItem: {
        borderRadius: 8,
        marginBottom: theme.spacing(1),
        cursor: 'pointer',
        border: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.15s',
        '&:hover': { backgroundColor: theme.palette.action.hover },
    },
    historyItemActive: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light + '22',
    },
    historyItemPermanent: {
        borderLeft: `4px solid ${theme.palette.success.main}`,
    },
    historyItemTemp: {
        borderLeft: `4px solid ${theme.palette.warning.main}`,
    },
    historyItemLabel: {
        fontWeight: 600,
        fontSize: '0.85rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    historyItemMeta: {
        fontSize: '0.72rem',
        color: theme.palette.text.secondary,
    },
    saveButtons: {
        display: 'flex',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
        marginTop: theme.spacing(1),
    },
}));

export default useStyles;
